const { connect } = require('react-redux');
const BrokerCustomWalletEditablePortfolio = require ('./brokerCustomWalletEditablePortfolio');
// @ actions
const bufferActions = require('../../actions/brokerCustomWalletEditablePortfolio');
const portfoliosActions = require('../../actions/brokerCustomWalletPortfolios');
const editablePortfolio = require('../../actions/brokerCustomWalletEditablePortfolio.js');

module.exports.BrokerCustomWalletEditablePortfolio = connect(
    state => ({
        immBrokerCustomWalletEditablePortfolio: state.brokerCustomWalletEditablePortfolio,
        immBrokerCustomWalletInterveners: state.brokerCustomWalletInterveners,
        immIdPortfolioOnEdition: state.brokerCustomWalletPortfolios.get('idPortfolioOnEdition')
    }),
    {
        getDetailsByPortfolio: portfoliosActions.getDetailsByPortfolio,
        loadEditablePortfolioById: editablePortfolio.loadEditablePortfolioById,
        inputNameChange: bufferActions.inputNameChange,
        changeSwitchItemContract: bufferActions.changeSwitchItemContract,
        setPortfolioToDelete: portfoliosActions.setPortfolioToDelete,
        setOnEditMode: portfoliosActions.setPortfolioOnEditionMode,
        savePortfolio: bufferActions.savePortfolio,
        enableAllPortfolioContractsByType: bufferActions.enableAllPortfolioContractsByType,
        disableAllPortfolioContractsByType: bufferActions.disableAllPortfolioContractsByType,
        setDefaultViewOnCreate: bufferActions.setDefaultViewOnCreate
    }
)(BrokerCustomWalletEditablePortfolio);
